import { isExcluded } from '@/src/utils/is-excluded-path-patterns';

const OVERRIDES: Record<string, string> = {
  '/finansal-skor': '/finansal-skor/giris',
};

export function computeCallback(raw: string): string | null {
  const url = raw.startsWith('http') ? new URL(raw) : new URL(raw, process.env.HOST);

  const basePath = url.pathname;
  console.log('basepath', basePath, isExcluded(basePath));
  if (isExcluded(basePath)) return null;

  const destBase = OVERRIDES[basePath] ?? basePath;

  const callback = `${destBase}${url.search}${url.hash}`;

  return callback.startsWith('/') ? callback : `/${callback}`;
}
